(function () {
  'use strict';

  function initCopyButtons(root) {
    root.querySelectorAll('[data-lux-article-copy]').forEach(function (btn) {
      if (btn.dataset.luxCopyInit) return;
      btn.dataset.luxCopyInit = '1';
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-url') || window.location.href;
        var label = btn.textContent;
        function done() {
          btn.textContent = btn.classList.contains('lux-ah__share-btn') ? '✓' : '✓ Copied';
          window.setTimeout(function () {
            btn.textContent = label;
          }, 1800);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () {
            window.prompt('Copy this link:', url);
          });
        } else {
          window.prompt('Copy this link:', url);
        }
      });
    });
  }

  function enhanceContent(content) {
    content.querySelectorAll('blockquote').forEach(function (quote) {
      if (!quote.classList.contains('pull-quote')) {
        quote.classList.add('pull-quote');
      }
    });
    content.querySelectorAll('figure').forEach(function (figure) {
      if (!figure.classList.contains('inline-img')) {
        figure.classList.add('inline-img');
      }
    });
  }

  function initArticle(root) {
    if (!root || root.dataset.luxArticleInit) return;
    root.dataset.luxArticleInit = '1';

    var content = root.querySelector('[data-lux-article-content]');
    var toc = root.querySelector('[data-lux-article-toc]');
    var tocList = root.querySelector('[data-lux-article-toc-list]');
    var progressFill = root.querySelector('[data-lux-article-progress-fill]');
    var progressPct = root.querySelector('[data-lux-article-progress-pct]');

    initCopyButtons(root);

    if (content) {
      enhanceContent(content);
    }

    var tocLinks = [];

    if (content && toc && tocList) {
      var headings = content.querySelectorAll('h2, h3');
      if (headings.length) {
        headings.forEach(function (heading, index) {
          if (!heading.id) {
            heading.id = 'lux-article-section-' + (index + 1);
          }
          var item = document.createElement('li');
          var link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();
          link.className = 'lux-article-toc__link';
          if (heading.tagName === 'H3') {
            link.classList.add('is-sub');
          }
          link.addEventListener('click', function (event) {
            event.preventDefault();
            var top = heading.getBoundingClientRect().top + window.scrollY - 110;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
          item.appendChild(link);
          tocList.appendChild(item);
          tocLinks.push({ link: link, heading: heading });
        });
        toc.hidden = false;
      }
    }

    function updateProgress() {
      if (!content) return;
      var rect = content.getBoundingClientRect();
      var total = content.offsetHeight;
      var seen = Math.max(0, -rect.top + 100);
      var pct = total > 0 ? Math.min(100, Math.round((seen / total) * 100)) : 0;

      if (progressFill) progressFill.style.width = pct + '%';
      if (progressPct) progressPct.textContent = pct + '%';

      if (!tocLinks.length) return;

      var activeIndex = 0;
      tocLinks.forEach(function (entry, index) {
        if (entry.heading.getBoundingClientRect().top < 160) {
          activeIndex = index;
        }
      });

      tocLinks.forEach(function (entry, index) {
        entry.link.classList.toggle('is-active', index === activeIndex);
      });
    }

    if (content && (progressFill || tocLinks.length)) {
      updateProgress();
      window.addEventListener('scroll', updateProgress, { passive: true });
    }
  }

  function boot() {
    document.querySelectorAll('[data-lux-article]').forEach(initArticle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lux-article]');
    if (root) initArticle(root);
  });
})();
